/**
 * Step navigation and focus management
 */

import { getLocaleDateFormat } from '../utils/dateHelpers.js';
import { getStepForField } from '../steps.js';

// The steps that hold the two values that lock when the account is created.
// Derived from the step order, so a reordered step moves the confirm gate with it.
export const BIRTHDAY_STEP = getStepForField('birthday');
export const SEX_STEP = getStepForField('sex');

const INPUT_SELECTORS = {
    1: '#email',
    2: '#name',
    3: null, // Birthday - determined dynamically based on date format
    4: null, // Sex - the chosen option, or the first one (see getSexOptionSelector)
    5: '#suCityName',
    6: '#suHomeCityName',
    7: '#password',
    8: '#username'
};

const BIRTHDAY_ORDER = {
    MDY: ['month', 'day', 'year'],
    YMD: ['year', 'month', 'day'],
    DMY: ['day', 'month', 'year'],
};

// The first empty birthday select in the locale's date order, or the first one.
function getBirthdayFieldSelector() {
    const names = BIRTHDAY_ORDER[getLocaleDateFormat()] || BIRTHDAY_ORDER.DMY;
    const empty = names.find((name) => !document.querySelector(`select[name="${name}"]`)?.value);

    return `select[name="${empty || names[0]}"]`;
}

// A radio group takes focus on its checked option.
function getSexOptionSelector() {
    const checked = '#signupForm [role="radio"][aria-checked="true"]';

    return document.querySelector(checked) ? checked : '#signupForm [role="radio"]';
}

export function focusCurrentInput(step) {
    let selector = INPUT_SELECTORS[step];

    if (step === BIRTHDAY_STEP) {
        selector = getBirthdayFieldSelector();
    }

    if (step === SEX_STEP) {
        selector = getSexOptionSelector();
    }

    if (selector) {
        const input = document.querySelector(selector);
        if (input) {
            // Focus immediately to maintain user gesture chain for mobile keyboard
            input.focus();

            // On mobile, also trigger click to ensure keyboard appears.
            // A click on a sex option would choose it.
            if ('ontouchstart' in window && step !== SEX_STEP) {
                input.click();
            }
        }
    }
}

export function isCityStep(step) {
    return step === 5 || step === 6;
}

export function getCityInputId(step) {
    return step === 5 ? 'suCityName' : 'suHomeCityName';
}
